module.exports = __webpack_public_path__ + "img/american-public-power-association-TF-DL_2L1JM-unsplash.164f459f.jpg";